"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var React = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _internalTypography = require("../../../internal/internal-typography");
var _constants = require("../../../utils/constants");
var _material_ui_theme = _interopRequireDefault(require("../text_input/material_ui_theme"));
var _flyout = _interopRequireDefault(require("./flyout"));
var _selected_chips = _interopRequireDefault(require("./selected_chips"));
var _theme = _interopRequireDefault(require("../text_input/theme"));
var _end_adornment = _interopRequireDefault(require("./end_adornment"));
var _use_input_auto_width = _interopRequireDefault(require("./use_input_auto_width"));
var _excluded = ["dropdownProps"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var FieldWrapper = _styledComponents["default"].div.withConfig({
  displayName: "multi_dropdown__FieldWrapper"
})(["min-width:300px;"]);
var MultiDropdown = function MultiDropdown(_ref) {
  var children = _ref.children;
  var _React$useState = React.useState(null),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    anchorEl = _React$useState2[0],
    setAnchorEl = _React$useState2[1];
  return /*#__PURE__*/React.createElement(FieldWrapper, null, React.Children.map(children, function (child) {
    return /*#__PURE__*/React.cloneElement(child, {
      anchorEl: anchorEl,
      setAnchorEl: setAnchorEl
    });
  }));
};
MultiDropdown.displayName = 'MultiDropdown';
var MultiDropdownFlyout = function MultiDropdownFlyout(props) {
  return /*#__PURE__*/React.createElement(_flyout["default"], props);
};
MultiDropdownFlyout.displayName = 'MultiDropdown.Flyout';
MultiDropdown.Flyout = MultiDropdownFlyout;
var StartAdornment = function StartAdornment(props) {
  return /*#__PURE__*/React.createElement(_selected_chips["default"], props);
};
var MultiDropdownField = function MultiDropdownField(_ref2) {
  var dropdownProps = _ref2.dropdownProps,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  var getComboboxProps = dropdownProps.getComboboxProps,
    getDropdownProps = dropdownProps.getDropdownProps,
    getInputProps = dropdownProps.getInputProps,
    getLabelProps = dropdownProps.getLabelProps,
    getSelectedItemProps = dropdownProps.getSelectedItemProps,
    isOpen = dropdownProps.isOpen,
    openMenu = dropdownProps.openMenu,
    toggleMenu = dropdownProps.toggleMenu,
    removeSelectedItem = dropdownProps.removeSelectedItem,
    selectedItems = dropdownProps.selectedItems,
    reset = dropdownProps.reset,
    loadInitialOptions = dropdownProps.loadInitialOptions;
  var label = props.label,
    ariaLabel = props.ariaLabel,
    ariaLabelledBy = props.ariaLabelledBy,
    helperText = props.helperText,
    condensedUnitName = props.condensedUnitName,
    placeholder = props.placeholder,
    _props$error = props.error,
    error = _props$error === void 0 ? false : _props$error,
    _props$required = props.required,
    required = _props$required === void 0 ? false : _props$required,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$fullWidth = props.fullWidth,
    fullWidth = _props$fullWidth === void 0 ? true : _props$fullWidth;
  var inputValue = getInputProps().value;
  var showPlaceholder = selectedItems.length === 0 && placeholder && inputValue.length === 0;

  // eslint-disable-next-line react-hooks/rules-of-hooks
  var classes = (0, _material_ui_theme["default"])(props);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  var inputWidth = (0, _use_input_auto_width["default"])({
    textValue: showPlaceholder ? placeholder : inputValue,
    anchorEl: props.anchorEl
  });
  var HelperTextComponent = !error ? _internalTypography.HelperText : _internalTypography.DangerHelperText;
  return /*#__PURE__*/React.createElement("div", getComboboxProps(), /*#__PURE__*/React.createElement(StyledTextField, (0, _extends2["default"])({}, (0, _constants.getDataProvidesProps)(props), {
    label: label,
    error: error,
    required: required,
    disabled: disabled,
    variant: "filled",
    size: "medium",
    $isOpen: dropdownProps.isOpen,
    fullWidth: fullWidth,
    helperText: helperText && /*#__PURE__*/React.createElement(HelperTextComponent, null, helperText),
    placeholder: showPlaceholder ? placeholder : undefined,
    FormHelperTextProps: {
      className: classes.helperText
    },
    inputProps: {
      className: classes.htmlInput,
      'aria-label': ariaLabel,
      'aria-labelledby': ariaLabelledBy,
      style: {
        flexBasis: "".concat(inputWidth, "px"),
        width: "".concat(inputWidth, "px")
      }
    },
    InputProps: _objectSpread(_objectSpread({
      ref: props.setAnchorEl
    }, getInputProps(_objectSpread(_objectSpread({}, getDropdownProps()), {}, {
      refKey: 'inputRef'
    }))), {}, {
      onClick: function onClick() {
        if (!disabled && !isOpen) {
          loadInitialOptions();
          openMenu();
        }
      },
      startAdornment: /*#__PURE__*/React.createElement(StartAdornment, {
        condensedUnitName: condensedUnitName,
        flyoutIsOpen: dropdownProps.isOpen,
        selectedItems: selectedItems,
        removeSelectedItem: removeSelectedItem,
        reset: reset,
        getSelectedItemProps: getSelectedItemProps,
        labeled: !!label
      }),
      endAdornment: /*#__PURE__*/React.createElement(StyledEndAdornment, {
        resettable: selectedItems.length > 1,
        onReset: reset,
        toggleMenu: toggleMenu,
        disabled: disabled
      }),
      classes: {
        root: classes.inputWrapper,
        underline: classes.inputWrapperUnderline,
        adornedStart: classes.adornedStart,
        adornedEnd: classes.adornedEnd
      }
    }),
    InputLabelProps: _objectSpread(_objectSpread({}, getLabelProps()), {}, {
      classes: {
        root: classes.inputLabel,
        asterisk: classes.requiredAsterisk,
        focused: classes.focusedInputLabel
      },
      disableAnimation: true,
      shrink: false
    })
  })));
};
MultiDropdownField.displayName = 'MultiDropdown.Field';
MultiDropdown.Field = MultiDropdownField;

// account for absolutely positioned end adornment
var endAdornmentWidth = '65px';
var StyledTextField = (0, _styledComponents["default"])(_core.TextField).withConfig({
  displayName: "multi_dropdown__StyledTextField"
})(["& .MuiInputBase-input{flex:1 0 5rem;}&&&&&&&&&& .MuiInputBase-root{display:flex;box-sizing:border-box;flex-wrap:wrap;gap:0.5rem;row-gap:0.25rem;", " white-space:nowrap;}&&&&&&&&&& .MuiInputBase-input{flex-grow:0;max-width:100%;padding:0;}", ""], function (_ref3) {
  var label = _ref3.label;
  return label ? "padding: 1.75em calc(0.5rem + ".concat(endAdornmentWidth, ") 0.5rem 1rem;") : "padding: 0.625rem calc(0.5rem + ".concat(endAdornmentWidth, ") 0.625rem 1rem;\n    ");
}, function (_ref4) {
  var $isOpen = _ref4.$isOpen;
  return $isOpen && "\n  &&&&&&&&&& .MuiInputBase-root {\n    border-radius: 4px 4px 0 0;\n    border-color: ".concat(_theme["default"]["default"].borderColor, ";\n  }\n  ");
});
var StyledEndAdornment = (0, _styledComponents["default"])(_end_adornment["default"]).withConfig({
  displayName: "multi_dropdown__StyledEndAdornment"
})(["top:0;bottom:0;right:1rem;position:absolute;"]);
var _default = MultiDropdown;
exports["default"] = _default;